import ExternalFormsContainer from './ExternalFormsContainer.tsx';

export default ExternalFormsContainer;
